import React, { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Collapse
} from "reactstrap"
import DYCTermsModal from "../../../DonateYourCard/DYCTermsModal"
import AboutDYCModal from "../../../DonateYourCard/AboutDYCModal"
import DYCFaqsModal from "../../../DonateYourCard/DYCFaqsModal"
import LoginModal from "../../../Common/LoginModal"
import { useUserData } from "../../../../Context/user"
import { srcLogo } from "../../../../images"
import styles from "./styles.module.scss"

export default function HeaderFullSize({ isDonateYourCard, selectedCharity }) {
  const [collapsed, setCollapsed] = useState(false)
  const [showDYCTerms, setShowDYCTerms] = useState(false)
  const [showDYCAbout, setShowDYCAbout] = useState(false)
  const [showDYCFaqs, setShowDYCFaqs] = useState(false)
  const [openLoginModal, setOpenLoginModal] = useState(false)
  const { loggedInUser, setUser } = useUserData()
  const navigate = useNavigate()

  const handleUserClick = () => {
    if (loggedInUser) {
      navigate("/Account")
    } else {
      setOpenLoginModal(true)
    }
  }

  const handleLoginSuccess = (user) => {
    setOpenLoginModal(false)
    setUser(user)
  }

  const logoAltText = (isDonateYourCard
    ? ("Donating your merchant card is powered by CharityChoice, offering over 2,500 carefully vetted charities to donate the unused balance to" +
      (selectedCharity ? `, including ${selectedCharity.CharityName}.` : "."))
    : "CharityChoice logo - number one and best charity gift card. Tax deductible  and 100% charitable.")

  return (
    <section className={styles.container}>
      <nav className={styles.content}>
        <Link className={styles.logo} to='/'>
          <img
            src={srcLogo}
            alt={logoAltText}
            longdesc="Tax deductible Donation Gift Cards. The best charity gift a meaningful, thoughtful way of 'giving back'. Choose from causes who help with animal protection and shelters, environment, homeless, education, food banks, children, disease, research and health, disaster relief, floods, tornados, tsunamis, hurricanes, earthquakes."
          />
        </Link>
        <div className={styles.navbarButtons}>
          <button
            type="button"
            className={styles.btnUser}
            onClick={handleUserClick}
            aria-label={loggedInUser ? "My account" : "Login"}>
            <i className="fa-regular fa-user" />
            <span className={styles.togglerLabel}>
              {loggedInUser ? `Hi ${loggedInUser.FirstName}!` : "Login"}
            </span>
          </button>
          <div
            className={styles.navbarToggler}
            onClick={() => setCollapsed(!collapsed)}>
            <i className="fa fa-bars" />
          </div>
        </div>
        <div className={styles.navLinks}>
          {!!isDonateYourCard
            ? (<>
              <div className={styles.navLink} onClick={() => { setShowDYCAbout(!showDYCAbout) }}>
                About
              </div>
              <AboutDYCModal
                isOpen={showDYCAbout}
                onToggle={() => setShowDYCAbout(!showDYCAbout)} />
              <div className={styles.navLink} onClick={() => { setShowDYCTerms(!showDYCTerms) }}>
                Terms
              </div>
              <DYCTermsModal
                isTermsOpen={showDYCTerms}
                onToggleTerms={() => setShowDYCTerms(!showDYCTerms)} />
              <div className={styles.navLink} onClick={() => { setShowDYCFaqs(!showDYCFaqs) }}>
                FAQs
              </div>
              <DYCFaqsModal
                isFaqsOpen={showDYCFaqs}
                onToggleFaqs={() => setShowDYCFaqs(!showDYCFaqs)} />
              <Link className={styles.navLink} to="/OurCharities" state={{ isDonateYourCard: true }}>
                Our Charities
              </Link>
            </>)
            : (<>
              <Link className={styles.navLink} to="/About">
                About
              </Link>
              <UncontrolledDropdown>
                <DropdownToggle nav caret className={styles.navLink}>
                  Shop
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem tag={Link} to="/Purchase/PhysicalCards">
                    <span className="nav-link">Physical Cards</span>
                  </DropdownItem>
                  <DropdownItem tag={Link} to="/Purchase/DigitalCards">
                    <span className="nav-link">Digital Cards</span>
                  </DropdownItem>
                  <DropdownItem tag={Link} to="/Purchase/CustomPhysicalCards">
                    <span className="nav-link" id="customPhysicalCardsHelp">
                      Custom Gift Cards {"  "}
                      <i className="fa fa-info-circle" />
                    </span>
                  </DropdownItem>
                  <DropdownItem tag={Link} to="/Purchase/DigitalCards">
                    <span className="nav-link">Printable Cards</span>
                  </DropdownItem>
                  <DropdownItem tag={Link} to="/Purchase/HonorCards">
                    <span className="nav-link">Honor Cards</span>
                  </DropdownItem>
                  <DropdownItem tag='a' href="/Purchase/RedemptionCodes">
                    <span className="nav-link">Redemption Codes</span>
                  </DropdownItem>
                  <DropdownItem tag={Link} to="/Purchase/Favors-Swag-QR-Codes">
                    <span className="nav-link">Multi-Redeemable QR Codes</span>
                  </DropdownItem>
                  <DropdownItem tag={Link} to="/Purchase/DirectToCharityDonation">
                    <span className="nav-link">Direct Donation</span>
                  </DropdownItem>
                  <DropdownItem tag="a" href="https://DonateYourCard.org" target="_blank" rel="noopener noreferrer">
                    <span className="nav-link">DonateYourCard.org</span>
                    <span className={styles.nav_link_subtext}>
                      Unused gift card balances
                    </span>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              <Link className={styles.navLink} to="/CorporateSolutions">
                Corporate Solutions
              </Link>
              <Link className={styles.navLink} to="/Charities">
                Our Charities
              </Link>
            </>)}

          <Link className={styles.navLink} to="/Contact">
            Contact Us
          </Link>
        </div>
      </nav>
      <Collapse className={styles.navMenuContent} isOpen={collapsed}>
        <Link className={styles.menuLink} to="/About" state={{ isDonateYourCard }}>
          About
        </Link>
        {!isDonateYourCard && (<>
          <div className={styles.menuLink}>Shop</div>
          <div className={styles.subLinks}>
            <Link className={styles.menuLink} to="/Purchase/PhysicalCards">
              Physical Cards
            </Link>
            <Link className={styles.menuLink} to="/Purchase/DigitalCards">
              Digital Cards
            </Link>
            <Link className={styles.menuLink} to="/Purchase/Favors-Swag-QR-Codes">
              Multi-Redeemable QR Codes
            </Link>
            <Link className={styles.menuLink} to="/Purchase/CustomPhysicalCards">
              Custom Gift Cards{"  "}
              <i className="fa fa-info-circle" />
            </Link>
            <Link className={styles.menuLink} to="/Purchase/DigitalCards">
              Printable Cards
            </Link>
            <Link className={styles.menuLink} to="/Purchase/HonorCards">
              Honor Cards
            </Link>
            <a className={styles.menuLink} href="/Purchase/RedemptionCodes">
              Redemption Codes
            </a>
            <Link
              className={styles.menuLink}
              to="/Purchase/DirectToCharityDonation">
              Direct Donation
            </Link>
            <a className={styles.menuLink} href="https://donateyourcard.org">
              Donate Retail Cards
            </a>
          </div>
          <Link className={styles.menuLink} to="/CorporateSolutions">
            Corporate Solutions
          </Link>
        </>)}
        <Link className={styles.menuLink} to="/Charities">
          Our Charities
        </Link>
        <Link className={styles.menuLink} to="/Contact">
          Contact Us
        </Link>
      </Collapse>
      <LoginModal
        isOpen={openLoginModal}
        caption="Log In"
        onClose={() => setOpenLoginModal(false)}
        onSuccess={handleLoginSuccess}
      />
    </section>
  )
}